module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_1.a6988090.png";